/**
 * Created by mykurisu on 2017/7/3.
 */
import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import WKOwmDialog from '../../components/wk/WKOwnDialog'
import refundPic from '../../images/refundPic.jpg'
import { Dialog, Form, FormCell, Checkbox, Agreement, Icon } from 'react-weui'
import '../../styles/record/RecordRefund.css'

class RecordRefund extends React.Component {
  constructor () {
    super()
    this.handleAgreeSelect = this.handleAgreeSelect.bind(this)
    this.handleRefundPanelHide = this.handleRefundPanelHide.bind(this)
    this.handleReasonValue = this.handleReasonValue.bind(this)
    this.handlePhoneNumValue = this.handlePhoneNumValue.bind(this)
    this.handleRefundSubmit = this.handleRefundSubmit.bind(this)
    this.state = {
      selectBtn: null,
      refundPanel: {
        buttons: [
          {
            type: 'default',
            label: '再考虑下',
            onClick: this.handleRefundPanelHide
          },
          {
            type: 'primary',
            label: '申请退款',
            onClick: this.handleRefundSubmit
          }
        ]
      },
      refundReason: '',
      refundPhoneNum: '',
      agreeBtn: false
    }
  }

  handleAgreeSelect () {
    this.setState({
      agreeBtn: !this.state.agreeBtn
    })
  }

  handleRefundPanelHide () {
    this.setState({
      refundReason: '',
      refundPhoneNum: '',
      selectBtn: null
    })
    let selectList = document.querySelectorAll('.weui-check')
    for (let i = 0; i < selectList.length; i++) {
      if (selectList[i].checked) {
        selectList[i].checked = false
      }
    }
    this.props.handleRefundPanelHide()
  }

  handleOneSelect (e) {
    let selectList = document.querySelectorAll('.weui-check')
    for (let i = 0; i < selectList.length; i++) {
      if (selectList[i].checked) {
        selectList[i].checked = false
      }
    }
    e.target.checked = true
    this.setState({
      selectBtn: Number(e.target.value)
    })
  }

  handleReasonValue (e) {
    this.setState({
      refundReason: e.target.value
    })
  }

  handlePhoneNumValue (e) {
    const tel = e.target.value.replace(/[^\d]/g, '')
    this.setState({
      refundPhoneNum: tel
    })
  }

  handleRefundSubmit () {
    const { isWhiteAccount, selectInvoice, account, item } = this.props
    const { selectBtn, refundReason, refundPhoneNum } = this.state
    let argee = document.querySelector('.weui-agree__checkbox')
    // let reg = /^(0|86|17951)?(13[0-9]|15[012356789]|18[0-9]|14[57]|17[678])[0-9]{8}$/;
    let arr = []
    if (item === 'liveroom_vip') {
      arr[0] = '误以为VIP会员可收听全平台课程'
      arr[1] = '不小心点错购买了'
      arr[2] = '店铺内有部分课程无法收听'
      arr[3] = '老师没有讲课'
    } else {
      arr[0] = '不小心点错了，想买单课'
      arr[1] = '老师没有讲课'
      arr[2] = '专栏内课程开课时间间隔太长'
      arr[3] = '课程与专栏介绍不一样'
    }
    if (selectBtn !== 0) {
      if (selectBtn !== 5) {
        if (refundPhoneNum === '') {
          this.context.page.showTips('请填写退款理由和联系方式', 'warn')
        } else {
          /*else if (!reg.test(refundPhoneNum.replace(/\s+/g, ""))){
                    this.context.page.showTips('请填写正确的联系方式', 'warn');
                }*/ if (
            isWhiteAccount ||
            argee.checked
          ) {
            let data = new FormData()
            //data.append('invoice_id', selectInvoice);
            data.append('telephone', this.state.refundPhoneNum)
            switch (this.state.selectBtn) {
              case 1:
                data.append('reason', arr[0])
                break
              case 2:
                data.append('reason', arr[1])
                break
              case 3:
                data.append('reason', arr[2])
                break
              case 4:
                data.append('reason', arr[3])
                break
              default:
                break
            }
            axios
              .post(`/api/invoice/${selectInvoice}/refund/apply`, data)
              .then((res) => {
                if (res.data.code === 0) {
                  this.props.handleRefundPanelHide()
                  this.props.handleRefundSuccess(selectInvoice)
                  let text = () => {
                    return (
                      <div className="record-page-showalert">
                        <Icon size="large" value="success" />
                        <p className="record-page-showalert_title">提交成功</p>
                        {!account.subscribed && (
                          <div className="record-page-showalert_qrcode">
                            <img
                              className="qrcode-img"
                              src={res.data.data.qrcode_url}
                              style={{ width: '90px' }}
                              alt=""
                            />
                          </div>
                        )}
                        <p className="record-page-showalert_text">
                          你的退款申请已经提交给讲师
                        </p>
                        {!account.subscribed ? (
                          <p className="record-page-showalert_text">
                            长按扫码关注，接收退款通知
                          </p>
                        ) : (
                          <p className="record-page-showalert_text">
                            退款结果将通过公众号通知你
                          </p>
                        )}
                      </div>
                    )
                  }
                  this.context.page.showRefundAlert(text())
                  /*this.setState({
                                    refundReason: '',
                                    refundPhoneNum: ''
                                });
                                let selectList = document.querySelectorAll('.weui-check');
                                for (let i = 0;i < selectList.length;i++){
                                    if (selectList[i].checked){
                                        selectList[i].checked = false
                                    }
                                }*/
                } else {
                  this.context.page.showTips(res.data.msg, 'warn')
                }
              })
          } else {
            this.context.page.showTips('您尚未同意退款条款和手续费收取', 'warn')
          }
        }
      } else {
        if (
          refundReason === '' ||
          refundReason.replace(/(^\s*)|(\s*$)/g, '').length === 0
        ) {
          this.context.page.showTips('请填写退款理由和联系方式', 'warn')
        } else {
          if (refundPhoneNum === '') {
            this.context.page.showTips('请填写退款理由和联系方式', 'warn')
          } else {
            /*else if (!reg.test(refundPhoneNum.replace(/\s+/g, ""))){
                        this.context.page.showTips('请填写正确的联系方式', 'warn');
                    } */ if (
              isWhiteAccount ||
              argee.checked
            ) {
              let data = new FormData()
              //data.append('invoice_id', selectInvoice);
              data.append('telephone', this.state.refundPhoneNum)
              data.append('reason', this.state.refundReason)
              axios
                .post(`/api/invoice/${selectInvoice}/refund/apply`, data)
                .then((res) => {
                  if (res.data.code === 0) {
                    this.props.handleRefundPanelHide()
                    this.props.handleRefundSuccess(selectInvoice)
                    let text = () => {
                      return (
                        <div className="record-page-showalert">
                          <Icon size="large" value="success" />
                          <p className="record-page-showalert_title">提交成功</p>
                          {!account.subscribed && (
                            <div className="record-page-showalert_qrcode">
                              <img
                                className="qrcode-img"
                                src={res.data.data.qrcode_url}
                                style={{ width: '90px' }}
                                alt=""
                              />
                            </div>
                          )}
                          <p className="record-page-showalert_text">
                            你的退款申请已经提交给讲师
                          </p>
                          {!account.subscribed ? (
                            <p className="record-page-showalert_text">
                              长按扫码关注，接收退款通知
                            </p>
                          ) : (
                            <p className="record-page-showalert_text">
                              退款结果将通过公众号通知你
                            </p>
                          )}
                        </div>
                      )
                    }
                    this.context.page.showRefundAlert(text())
                    /*this.setState({
                                        refundReason: '',
                                        refundPhoneNum: '',
                                        selectBtn: 0
                                    });
                                    let selectList = document.querySelectorAll('.weui-check');
                                    for (let i = 0;i < selectList.length;i++){
                                        if (selectList[i].checked){
                                            selectList[i].checked = false
                                        }
                                    }*/
                  } else {
                    this.context.page.showTips(res.data.msg, 'warn')
                  }
                })
            } else {
              this.context.page.showTips('你未同意退款条款', 'warn')
            }
          }
        }
      }
    } else {
      this.context.page.showTips('请填写退款理由和联系方式', 'warn')
    }
  }

  render () {
    const { isWhiteAccount, RefundShow, item } = this.props
    const { refundPanel, selectBtn, refundReason, refundPhoneNum } = this.state
    return (
      <div className="record-page-refund">
        {/*<WKOwmDialog type='ios' title='提交成功' buttons={[lable:'关闭', onClick:]}>*/}

        {/*</WKOwmDialog>*/}
        <Dialog
          className="refund-reason-dialog"
          type="ios"
          title="选择退款原因"
          buttons={refundPanel.buttons}
          show={RefundShow}>
          <Form checkbox>
            <div
              className="record-page-refund-checkbox"
              onClick={this.handleOneSelect.bind(this)}>
              <FormCell
                checkbox
                style={{ color: selectBtn === 1 ? '#1AAD19' : '' }}>
                <Checkbox name="checkbox1" value="1" />
                {item === 'liveroom_vip' ? '误以为VIP会员可收听全平台课程' : '不小心点错了，想买单课'}
              </FormCell>
              <FormCell
                checkbox
                style={{ color: selectBtn === 2 ? '#1AAD19' : '' }}>
                <Checkbox name="checkbox2" value="2" />
                {item === 'liveroom_vip' ? '不小心点错购买了' : '老师没有讲课'}
              </FormCell>
              <FormCell
                checkbox
                style={{ color: selectBtn === 3 ? '#1AAD19' : '' }}>
                <Checkbox name="checkbox3" value="3" />
                {item === 'liveroom_vip' ? '店铺内有部分课程无法收听' : '专栏内课程开课时间间隔长'}
              </FormCell>
              <FormCell
                checkbox
                style={{ color: selectBtn === 4 ? '#1AAD19' : '' }}>
                <Checkbox name="checkbox4" value="4" />
                {item === 'liveroom_vip' ? '老师没有讲课' : '课程与专栏介绍不一样'}
              </FormCell>
              <FormCell
                checkbox
                style={{ color: selectBtn === 5 ? '#1AAD19' : '' }}>
                <Checkbox name="checkbox5" value="5" />
                其他
              </FormCell>
            </div>
            {selectBtn === 5 && (
              <div className="record-page-refund-input record-page-refund-input_first">
                <input
                  type="text"
                  placeholder="请输入退款原因"
                  value={refundReason}
                  onChange={this.handleReasonValue}
                />
              </div>
            )}
            <div className="record-page-refund-input_title">
              <span>*</span>联系电话
            </div>
            <div className="record-page-refund-input">
              <input
                type="tel"
                placeholder="填写电话方便老师联系你"
                value={refundPhoneNum}
                onChange={this.handlePhoneNumValue}
                maxLength={11}
              />
            </div>
            {/* 如果是白名单就屏蔽这里 */}
            <div className="record-page-agreement">
              {!isWhiteAccount && (
                <div>
                  <Agreement
                    checked={this.state.agreeBtn}
                    onChange={this.handleAgreeSelect}>
                    &nbsp;&nbsp;已阅读并同意<a href="https://mp.weixin.qq.com/s/HeyxTwlax16T9wf0f7eT5w">
                      《退款相关条款》
                    </a>及退款时收取1%的手续费
                  </Agreement>
                </div>
              )}
            </div>
          </Form>
        </Dialog>
      </div>
    )
  }
}

RecordRefund.contextTypes = {
  page: React.PropTypes.object
}

export default connect((state) => ({
  account: state.account
}))(RecordRefund)



// WEBPACK FOOTER //
// ./src/pages/BoughtPage/RecordRefund.js